SparkleVersion = '3.35';